import './app/index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { MsalProvider } from '@azure/msal-react';
import { FlagsProvider } from 'flagged';

import { App } from './app/App';
import { featureConfig,msalInstance } from './app/config';
import { store } from './app/store';
import { reportWebVitals } from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <FlagsProvider features={ featureConfig }>
        <StoreProvider store={store}>
            <React.StrictMode>
                <MsalProvider instance={msalInstance}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </MsalProvider>
            </React.StrictMode>
        </StoreProvider>
    </FlagsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint.
reportWebVitals();
